import {useTheme} from '@mui/material'
import React from 'react'
import {useNotification} from '../../../common/notifications/useNotification'
import {AllBoxesDocument, useUnlockCompartmentMutation} from '../../../generated/graphql'
import {Button} from '../../../webui/Button'
import {ButtonWithLoading} from '../../../webui/ButtonWithLoading'
import {Dialog} from '../../../webui/Dialog'
import {DialogActions} from '../../../webui/DialogActions'
import {DialogContent} from '../../../webui/DialogContent'
import {DialogContentText} from '../../../webui/DialogContentText'
import {DialogTitle} from '../../../webui/DialogTitle'

interface UnlockButtonProps {
  compartmentId: string
}

export const UnlockButton: React.FC<UnlockButtonProps> = ({compartmentId}) => {
  const theme = useTheme()
  const [open, setOpen] = React.useState(false)

  const [unlockCompartment, {loading}] = useUnlockCompartmentMutation({
    refetchQueries: [{query: AllBoxesDocument}],
  })

  const {showNotification} = useNotification()

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const onClose = () => {
    handleClose()
  }

  const onConfirm = async () => {
    try {
      const result = await unlockCompartment({variables: {compartmentId}})
      showNotification({
        message: 'Compartment unlocked.',
        severity: 'success',
      })
      console.log('Compartment unlocked!', result?.data?.unlockCompartment?.compartment)
      handleClose()
    } catch (e) {
      showNotification({
        message: 'Could not unlock compartment.',
        severity: 'error',
      })
      console.log('Compartment lock error', e, '--- e')
    }
  }

  return (
    <>
      <Button
        sx={{
          backgroundColor: theme.palette.success.light,
        }}
        onClick={handleClickOpen}
      >
        Unlock
      </Button>
      <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">Unlock the compartment?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to unlock the compartment? All users will be able to use it until you lock it again!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Keep it locked
          </Button>
          <ButtonWithLoading loading={loading} onClick={onConfirm} color="primary" autoFocus>
            Unlock
          </ButtonWithLoading>
        </DialogActions>
      </Dialog>
    </>
  )
}
